import { FIELD_PARENT_ACTIVITY_KEY } from "PFApp/constants/activity_form/activity_form_field_keys";
import { useIsFormChanged } from "PFApp/hooks/activity_form/use_is_form_changed";
import { Flex, Stack } from "PFComponents/containers";
import { RouterPrompt } from "PFComponents/router_prompt/router_prompt";
import { Activity } from "PFCore/types";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";

import css from "./activity_form.module.scss";
import { useActivityFormStore } from "./activity_form_store";
import { useActivityFormAutoSubmit } from "./hooks/use_activity_form_submit";
import { useSetFormSchema } from "./hooks/use_set_form_schema";
import { useSetHTMLStyles } from "./hooks/use_set_html_styles";
import { FormModals } from "./parts/confirmation_modals";
import { Footer } from "./parts/footer";
import { FormBody } from "./parts/form_body";
import { Header } from "./parts/header";
import { Navigation } from "./parts/navigation";
import { ParentEngagementBar } from "./parts/parent_engagement_bar";

export const ActivityForm = () => {
  const { t } = useTranslation("activities");
  const formSchema = useActivityFormStore((state) => state.formSchema);
  const isSmallScreen = useMediaQuery({ query: "(max-width: 1024px)" });
  const isChanged = useIsFormChanged();
  const selectedParentActivity: Activity | undefined = useWatch({ name: FIELD_PARENT_ACTIVITY_KEY });
  const isEngagementBarVisible = !!selectedParentActivity;

  useActivityFormAutoSubmit();
  useSetFormSchema();
  useSetHTMLStyles({ isEngagementBarVisible, isSmallScreen });

  if (!formSchema) {
    return null;
  }

  return (
    <>
      <Stack gap={null} className={css.pageWrapper}>
        <Header isSmallScreen={isSmallScreen} />
        {isEngagementBarVisible && (
          <ParentEngagementBar
            isSmallScreen={isSmallScreen}
            selectedParentActivity={selectedParentActivity}
          />
        )}
        <Flex
          gap="spacingLg"
          direction={isSmallScreen ? "column" : "row"}
          className={css.formWrapper}
          role="form"
          aria-label={t("form.title")}
          qaId="ActivityForm.main"
        >
          <Navigation isSmallScreen={isSmallScreen} isEngagementBarVisible={isEngagementBarVisible} />
          <FormBody />
        </Flex>
      </Stack>
      <Footer />
      <FormModals />
      <RouterPrompt when={isChanged} />
    </>
  );
};
